import Vue from 'vue'
import store from './store'
import App from './App.vue'
import Router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './utils/rem'
import 'lib-flexible'
Vue.use(ElementUI)
// 引入axios
import axios from 'axios'
Vue.prototype.$axios = axios

Vue.config.productionTip = false

new Vue({
  store,
  router: Router,
  // scrollBehavior(to, from, savedPosition) {
  //   // 如果有保存的位置，则返回该位置
  //   if (savedPosition) {
  //     return savedPosition;
  //   }
  //   // 否则滚动到页面顶部
  //   return { x: 0, y: 0 };
  // },
  render: h => h(App),
}).$mount('#app')
